import { actions } from './dailyTreatmentIndex/actions'
import { getters } from './dailyTreatmentIndex/getters'
import { state } from './dailyTreatmentIndex/state'
import { mutations } from './dailyTreatmentIndex/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
